module.exports = __webpack_public_path__ + "img/COM.9c963709.svg";